module.exports = __webpack_public_path__ + "img/TV_clean_box02.8aef6955.jpg";